<template>

<div id="app">
    <router-view />  
  </div>
  <head>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
  </head>


</template>

<script>

export default {
  
 
 components: {

   
 },

}
</script>

<style>


</style>
